export const GET_EVENT_TYPE_COACHES = "GET_EVENT_TYPE_COACHES";
export const GET_EVENT_TYPE_COACH_BY_ID = "GET_EVENT_TYPE_COACH_BY_ID";
export const UPDATE_EVENT_TYPE_COACH = "UPDATE_EVENT_TYPE_COACH";
export const DELETE_EVENT_TYPE_COACH = "DELETE_EVENT_TYPE_COACH";
export const CREATE_EVENT_TYPE_COACH = "CREATE_EVENT_TYPE_COACH";
